import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    id: '',
    name: '',
    isAdmin: false,
    avatar: ''
  }
}
const localStoragekey = 'store/user'
function getStateFromLocalStorage() {
  let v
  try {
    const str = localStorage.getItem(localStoragekey)
    if (str) {
      v = JSON.parse(str)
    }

  } catch (ex) {
    console.error(ex)
  }
  if (!v) {
    v = getDefaultState()
  }
  return v
}
function setStateToLocalStorage(state) {
  try {
    localStorage.setItem(localStoragekey,
      JSON.stringify(state))
  } catch (ex) {
    console.error(ex)
  }
}
const state = getStateFromLocalStorage()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
    setStateToLocalStorage(state)
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    setStateToLocalStorage(state)
  },
  SET_NAME: (state, name) => {
    
    state.name = name
    setStateToLocalStorage(state)
  },
  SET_ID: (state, id) => {
    
    state.id = id
    setStateToLocalStorage(state)
  },
  SET_ADMIN: (state, isAdmin) => {
    
    state.isAdmin = isAdmin
    setStateToLocalStorage(state)
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
    setStateToLocalStorage(state)
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        debugger
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          return reject('Verification failed, please Login again.')
        }
debugger
        const { name, avatar } = data

        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
        removeToken() // must remove  token  first
        resetRouter()
        commit('RESET_STATE')
        resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

